import { Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import tippy, { Instance } from 'tippy.js';

@Directive({
  selector: '[tippy]'
})
export class TippyDirective implements OnChanges, OnDestroy {

  @Input('tippy') content: string = '';
  @Input() placement: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() theme: string = '';
  private instance: Instance | null = null;

  constructor(private el: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    const isContentEmpty = !this.content || this.content.toString().trim() === '';

    if (isContentEmpty) {
      if (this.instance) {
        this.instance.destroy();
        this.instance = null;
      }
      return;
    }

    if (!this.instance) {
      const result = tippy(this.el.nativeElement, {
        content: this.content,
        placement: this.placement,
        theme: this.theme,
        allowHTML: true,
        interactive: true,
        appendTo: document.body,
        arrow: false
      });

      this.instance = Array.isArray(result) ? result[0] : result;

    } else {
      this.instance.setProps({
        content: this.content,
        placement: this.placement,
        theme: this.theme,
      });
    }
  }

  ngOnDestroy() {
    if (this.instance) {
      this.instance.destroy();
    }
  }

}
